import styled from "styled-components";
import { sizes } from "../constants/sizes";
import { breakpoints } from "../constants/breakpoints";

export const BreadCrumbsContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 8px;
  display: flex;
  align-items: center;
  flex-direction: row;
  align-content: flex-start;
  flex-wrap: nowrap;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  max-width: ${sizes.tanya.breadcrumbWidth};
  scrollbar-width: none;
`;

export const BreadCrumbItem = styled.li`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.neutral[800]};
  text-transform: capitalize;
  white-space: nowrap;

  &:not(:last-child):after {
    content: ">";
    margin: 0 4px;
  }

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes.md};
  }
`;

export const BreadCrumbLink = styled.a`
  color: inherit;
  text-decoration: none;
`;
